import { Divider } from "@/components/shared/divider";
import { View } from "@/components/ui";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { Typography } from "@/components/shared/typography";
import { ServiceProfileList } from "@/containers/profile/service-profile/service-profile-list";
import {
  type ServiceProfileType,
  ServiceProfileTypeMap,
} from "@/containers/profile/service-profile/lib";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Redirect, useRoute } from "@/components/shared/router";
import { IconButton } from "@/components/ui/icon-button";
import { getPlatform } from "@/lib/utils";

export function ServiceProfileListPage() {
  const { isMobile } = useWindowDimensions();
  const { pull, push } = useRoute();
  const { type } = useParams<{ type: ServiceProfileType }>();

  if (type && !Object.keys(ServiceProfileTypeMap).includes(type)) {
    return <Redirect path="/profile/service-profile" />;
  }

  const handleBack = () => {
    if (getPlatform() === "web") {
      push({
        pageKey: "serviceProfile",
      });
    } else {
      pull();
    }
  };

  const pageTitle = useMemo(() => {
    if (type) {
      return `${ServiceProfileTypeMap[type]} Profiles`;
    }
    return "Services Profile";
  }, [type]);

  return (
    <View>
      <View className="flex flex-row items-center gap-2 p-4 md:mb-4 md:p-0">
        {type || isMobile ? (
          <IconButton
            variant={isMobile ? "ghost" : "secondary"}
            color="foreground"
            iconName="arrowLeft"
            rounded="full"
            className="p-0 md:px-3 md:py-2"
            onClick={handleBack}
          />
        ) : null}
        <Typography variant="label-md">{pageTitle}</Typography>
      </View>
      <Divider />
      <ServiceProfileList type={type} />
    </View>
  );
}
